<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "PageComponent",
};
</script>

<style scoped></style>
